// Some shared styles used by nav bar buttons.

import styled from 'astroturf/react';

import { ButtonLink } from 'js/design_system/link/ButtonLink';

export const NavButtonWrapper = styled.div`
  flex-basis: 220px;
  flex-shrink: 0;
`;

export const NavButtonLink = styled(ButtonLink)`
  width: 100%;
  height: 48px;
  text-align: center;
`;

export const IconAnchor = styled.a`
  @import './styles.scss';
  @extend .icon-nav;

  &:visited {
    color: #6b6b82;
  }
`;

export const IconButton = styled.button`
  @import './styles.scss';
  @extend .icon-nav;

  cursor: pointer;
`;

export const IconContainer = styled.div`
  margin: 2px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;

  > img {
    max-height: 20px;
    max-width: 18px;
  }

  > span {
    margin: -4px;
  }
`;

// Like IconContainer but positioned so an absolutely-positioned dot (e.g.
// GreenDot) anchors to it.
export const RelativeIconContainer = styled(IconContainer)`
  position: relative;
`;

// Green indicator dot used on nav icons (e.g. unseen results / new feature).
export const GreenDot = styled.div`
  position: absolute;
  top: 0;
  right: -3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--success-dark, #05b01c);
`;

export const IconLabel = styled.div`
  position: relative;
  white-space: nowrap;
`;

export const NotificationDot = styled.div`
  position: absolute;
  top: 0;
  right: -8px;
  margin-left: 4px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #bb0202;
`;
